var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNimoTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64.1 60.3",
    style: {
      enableBackground: "new 0 0 64.1 60.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9,60.3C6.7,60.3,0,53.6,0,45.3V23.8c0-8.3,6.7-15,14.9-15l5.2-0.1c0.9,0,1.7-0.2,2.6-0.6l17.7-7.9 C40.8,0.1,41.3,0,41.7,0c0.7,0,1.5,0.2,2,0.7c1,0.7,1.5,2,1.3,3.2L44.5,8c0,0.2,0,0.4,0.2,0.6c0.1,0.2,0.3,0.2,0.5,0.2h4 c8.2,0,14.9,6.7,14.9,14.9v21.6c0,8.2-6.7,14.9-14.9,14.9C49.2,60.2,14.9,60.3,14.9,60.3z M39,6.7L39,6.7L24.9,13 c-1.5,0.7-3,1-4.6,1L15,14.1c-5.3,0-9.7,4.3-9.7,9.6v21.6c0,5.3,4.3,9.6,9.6,9.6h34.2c5.3,0,9.6-4.3,9.6-9.6V23.8 c0-5.3-4.3-9.6-9.6-9.6L40,14c-0.4,0-0.8-0.2-1.1-0.5s-0.4-0.8-0.3-1.2l0.8-5.2c0-0.1,0-0.2-0.1-0.3C39.2,6.8,39.1,6.7,39,6.7z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3,30.2c-1.9,0-3.4-1.5-3.4-3.4s1.5-3.4,3.4-3.4s3.4,1.5,3.4,3.4C25.6,28.7,24.1,30.2,22.3,30.2z M43.4,30.9 c-0.3,0-0.6-0.1-0.8-0.3L39,28.2c-0.4-0.3-0.6-0.7-0.6-1.2s0.2-0.9,0.6-1.2l3.6-2.5c0.3-0.2,0.5-0.3,0.8-0.3c0.8,0,1.5,0.7,1.5,1.5 c0,0.5-0.2,0.9-0.6,1.2L42.4,27l1.8,1.3c0.4,0.3,0.6,0.7,0.6,1.2c0,0.4-0.2,0.8-0.5,1.1C44.2,30.8,43.8,30.9,43.4,30.9z M37,33.6 l-0.9-0.5c-3.7-2.1-8.2,0.5-8.2,4.8V39c0,4.2,4.6,6.9,8.2,4.8l0.9-0.5C40.6,41,40.6,35.7,37,33.6z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNimoTv);
export default __webpack_public_path__ + "static/media/nimo-tv.779c34c826ee567938561d875a6cfe2f.svg";
export { ForwardRef as ReactComponent };